import { Box, HStack, Tooltip, VStack } from '@chakra-ui/react';
import { Toast } from '@web-app/components/Toast';
import { Text } from '@web-app/components/Typography/Text';
import React, { Ref } from 'react';

type Props = {
  label: string;
  text?: string;
  subText?: string;
  subTextRef?: Ref<HTMLDivElement>;
  text2?: string;
  subText2?: string;
  subText2Ref?: Ref<HTMLDivElement>;
  textRef?: Ref<HTMLDivElement>;
  text2Ref?: Ref<HTMLDivElement>;
  tooltip?: string;
  tooltip2?: string;
};

export const HeaderInfoBlock = ({
  label,
  text,
  textRef,
  text2Ref,
  subTextRef,
  subText2Ref,
  text2,
  subText,
  subText2,
  tooltip,
  tooltip2,
}: Props) => {
  return (
    <VStack gap={0}>
      <Text textType="xxs" color="white" opacity={0.34}>
        {label}
      </Text>
      {text && (
        <HStack gap={1} alignItems="end">
          <Tooltip
            background="none"
            label={tooltip && <Toast withArrow text={tooltip} />}
          >
            <Box>
              <Text textType="sm" color="white" fontWeight={600}>
                <span ref={textRef}>{text}</span>
              </Text>
            </Box>
          </Tooltip>
          {!!subText && (
            <>
              <Text
                textType="xxs"
                color="white"
                opacity={0.34}
                customSx={{ lineHeight: '1.25rem' }}
              >
                <span ref={subTextRef}>{subText}</span>
              </Text>
              {!!text2 && (
                <>
                  <Text textType="sm" color="#D9D9D9" opacity={0.1}>
                    |
                  </Text>
                  <Tooltip
                    background="none"
                    label={tooltip2 && <Toast withArrow text={tooltip2} />}
                  >
                    <Box>
                      <Text textType="sm" color="white" fontWeight={600}>
                        <span ref={text2Ref}>{text2}</span>
                      </Text>
                    </Box>
                  </Tooltip>
                  <Text
                    textType="xxs"
                    color="white"
                    opacity={0.34}
                    customSx={{ lineHeight: '1.25rem' }}
                  >
                    <span ref={subText2Ref}>{subText2}</span>
                  </Text>
                </>
              )}
            </>
          )}
        </HStack>
      )}
    </VStack>
  );
};
